export const GET_MY_CREDIT_SUCCESS = 'GET_MY_CREDIT_SUCCESS'
export const GET_MY_CREDIT_FAIL = 'GET_MY_CREDIT_FAIL'
export const GET_LOANS_LIST_SUCCESS = 'GET_LOANS_LIST_SUCCESS'
export const GET_LOANS_LIST_FAIL = 'GET_LOANS_LIST_FAIL'
export const UPDATE_STEP ='UPDATE_STEP'
